/**
 * @desc 修改
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.PageViewModifyRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/view/modify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
